import { render, staticRenderFns } from "./WithoutPayDetailsData.vue?vue&type=template&id=5f05f7cb"
import script from "./WithoutPayDetailsData.vue?vue&type=script&lang=js"
export * from "./WithoutPayDetailsData.vue?vue&type=script&lang=js"
import style0 from "./WithoutPayDetailsData.vue?vue&type=style&index=0&id=5f05f7cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports